import styled from 'styled-components';
import { ReactComponent as SearchIcon } from './search.svg';
import { ICON_CSS_CONFIG } from '../../../Utilities/cssConfig';

const SearchIconStyled = styled(SearchIcon)`
    height: 35px;
    stroke-width: 3;
    fill: ${({ selected }) => (selected ? ICON_CSS_CONFIG.selected : ICON_CSS_CONFIG.normal)};
`;

export default SearchIconStyled;
